import { store } from 'helpers/localStorage'
import { ACCOUNT_LOGIN } from '@constants'

export default function action({ user, authToken, refreshToken }) {
  const account = { user, authToken, refreshToken }
  store('account', account)
  return { type: ACCOUNT_LOGIN, payload: account }
}
